export default class Parser3D {
  parse(source, params = null) {
    return null;
  }
}
